import { render, staticRenderFns } from "./group-sessions.vue?vue&type=template&id=4a79b394"
import script from "./group-sessions.vue?vue&type=script&lang=js"
export * from "./group-sessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports